// *https://www.registers.service.gov.uk/registers/country/use-the-api*
// import fetch from "cross-fetch";
import akmApi from "../../../../../../apis/akmApi";
import eduprimeApi from "../../../../../../apis/eduprimeApi";
import { CONFIG_AKM } from "../../../../../../config/ConfigAkm";
import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import { ThemeConsumer } from "react-bootstrap/esm/ThemeProvider";
import { CONFIG_API_BE } from "../../../../../../config";

function sleep(delay = 0) {
    return new Promise((resolve) => {
        setTimeout(resolve, delay);
    });
}

export default function AutocompleteSearchCity(props) {
    const [open, setOpen] = React.useState(false);
    const [search, setSearch] = React.useState(null);
    const [options, setOptions] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [loadError, setLoadError] = React.useState(false);

    React.useEffect(() => {
        let active = true;
        if (search !== null && props.idProvinsi) {
            setOpen(true);
            setOptions([]);
            setLoading(true);
            setLoadError(false);
            (async () => {
                try {
                    const response = await eduprimeApi.get(CONFIG_API_BE.API_GET_KAB_KOTA + props.idProvinsi);
                    if (active) setOptions(Array.isArray(response.data.list_kab_kota) ? response.data.list_kab_kota : []);
                } catch (error) {
                    if (active) { setOptions([]); setLoadError(true); }
                } finally {
                    if (active) setLoading(false);
                }
            })();
        }
        return () => { active = false; };
    }, [search, props.idProvinsi]);

    return (
        <Autocomplete
            size="small"
            disabled={!props.idProvinsi}
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            getOptionSelected={(option, value) => option.NAMA_KABUPATEN_KOTA === value.NAMA_KABUPATEN_KOTA}
            getOptionLabel={(option) => option.NAMA_KABUPATEN_KOTA}
            options={options}
            loading={loading}
            noOptionsText={loadError ? "Gagal memuat kota. Ketik ulang untuk mencoba lagi." : "Tidak ada kota yang cocok."}
            disableClearable={true}
            onChange={(event, value) => {
                console.info("value kota nih", value.ID_KABUPATEN_KOTA);
                props.handleChangeKota(value.ID_KABUPATEN_KOTA);
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Cari City"
                    variant="outlined"
                    onChange={(event) => {
                        setSearch(event.target.value);
                    }}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
        />
    );
}
